import React, { forwardRef, useMemo, useState } from 'react';
import { FieldProps, InjectedFieldProps } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';

import { RewardBenefitDto } from '../../types';
import EditBenefitsDialog from './EditBenefitsDialog';

type EditBenefitActionFieldProps = (FieldProps & InjectedFieldProps) & {
  record?: RewardBenefitDto;
  benefitLevelsById?: Record<string, string[]>;
  onBenefitSaved?: (benefitId: string, levels: string[]) => void;
  validAt?: string;
};

const EditBenefitActionField = forwardRef<HTMLLIElement, EditBenefitActionFieldProps>(
  ({ record, benefitLevelsById, onBenefitSaved, validAt }, ref) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const benefit = useMemo(() => {
      if (!record?.id || !benefitLevelsById) {
        return record;
      }

      if (!Object.prototype.hasOwnProperty.call(benefitLevelsById, record.id)) {
        return record;
      }

      return { ...record, levels: benefitLevelsById[record.id] };
    }, [benefitLevelsById, record]);

    return (
      <>
        <MenuItem ref={ref} onClick={handleOpen}>
          Edit
        </MenuItem>
        {open && (
          <EditBenefitsDialog
            open={open}
            onClose={handleClose}
            benefit={benefit}
            onSaved={onBenefitSaved}
            validAt={validAt}
          />
        )}
      </>
    );
  }
);

export default EditBenefitActionField;
